import type { Resolver } from 'cpool-schemas';
import { z } from 'zod';

import { ConsorsNotesTableDefinitionZod, LoanRequestsTableDefinitionZod } from '../tables';

type Arguments = {
    position?: number;
};

export const schemaLoanRequestResolver_GetUnreadConsorsNotes = z.array(
    z.object({
        antragsteller1: LoanRequestsTableDefinitionZod.shape.antragsteller1.unwrap(),
        createdAt: LoanRequestsTableDefinitionZod.shape.createdAt,
        loanRequestId: ConsorsNotesTableDefinitionZod.shape.loanRequestId,
        // notes are filtered server-side to status === CONSORS_ADD_NOTE_STATUSES.SUCCESS
        notes: ConsorsNotesTableDefinitionZod.shape.notes,
        subscriptionIdentifier: ConsorsNotesTableDefinitionZod.shape.subscriptionIdentifier,
    }),
);

export type SchemaLoanRequestResolver_GetUnreadConsorsNotes = z.infer<
    typeof schemaLoanRequestResolver_GetUnreadConsorsNotes
>;

export type LoanRequestResolver_GetUnreadConsorsNotes = Resolver<
    Arguments,
    SchemaLoanRequestResolver_GetUnreadConsorsNotes
>;
